module.exports = __webpack_public_path__ + "img/index6.a225433b.png";